import { render, staticRenderFns } from "./new-driver-info.vue?vue&type=template&id=9662c53e&scoped=true&"
import script from "./new-driver-info.vue?vue&type=script&lang=js&"
export * from "./new-driver-info.vue?vue&type=script&lang=js&"
import style0 from "./new-driver-info.vue?vue&type=style&index=0&id=9662c53e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9662c53e",
  null
  
)

export default component.exports